import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:5000/api';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://nextgentechies.sbs/siju_portal';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me'),
  changePassword: (currentPassword, newPassword) =>
    api.post('/auth/change-password', { currentPassword, newPassword }),
};

// Admin API
export const adminAPI = {
  // Clients
  getClients: () => api.get('/admin/clients'),
  getClient: (id) => api.get(`/admin/clients/${id}`),
  createClient: (data) => api.post('/admin/clients', data),
  updateClient: (id, data) => api.put(`/admin/clients/${id}`, data),
  deleteClient: (id) => api.delete(`/admin/clients/${id}`),
  
  // Project access
  grantAccess: (clientId, projectId) =>
    api.post(`/admin/clients/${clientId}/projects/${projectId}`),
  revokeAccess: (clientId, projectId) =>
    api.delete(`/admin/clients/${clientId}/projects/${projectId}`),
  
  // Projects & versions
  getProjects: () => api.get('/admin/projects'),
  getVersions: (projectId) => api.get(`/admin/projects/${projectId}/versions`),
  uploadVersion: (projectId, formData) =>
    api.post(`/admin/projects/${projectId}/versions`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  deleteVersion: (versionId) => api.delete(`/admin/versions/${versionId}`),
  
  // Analytics
  getAnalytics: () => api.get('/admin/analytics/downloads'),
};

// Client API
export const clientAPI = {
  getProjects: () => api.get('/client/projects'),
  getVersions: (projectId) => api.get(`/client/projects/${projectId}/versions`),
  downloadVersion: (versionId) => {
    const token = localStorage.getItem('token');
    window.open(
      `${API_BASE_URL}/client/download/${versionId}?token=${token}`,
      '_blank'
    );
  },
  getDownloads: () => api.get('/client/downloads'),
};

export default api;
